import React from "react";
import styles from "./help.module.css";

export default function Help() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>

        <div className={styles.card}>
          <h1 className={styles.title}>
            Свяжитесь с нами
          </h1>

          <p className={styles.text}>
            Если у вас есть вопросы, вы можете задать их, отправив письмо на почту
            <a href="mailto:potcha@gmail.com" className={styles.link}>
              {" "}potcha@gmail.com
            </a>.
          </p>

          <p className={styles.subtext}>
            Мы постараемся ответить в кратчайшие сроки.
          </p>

          <div className={styles.note}>
            Обычно ответ занимает до 24 часов.
          </div>
        </div>

        <div className={styles.imageWrapper}>
          <img
            src="https://static.tildacdn.com/tild6233-3233-4339-b535-643562373765/2022-06-27_11-42-45.png"
            alt="Sivil Lab"
            className={styles.image}
          />
        </div>

      </div>
    </div>
  );
}